import { ArrowRight } from "lucide-react";

// Sharp, editorial Amazon CTA. variant: "solid" | "outline"
export const AmazonButton = ({
  href,
  children,
  variant = "solid",
  size = "lg",
  testId,
  className = "",
}) => {
  const base =
    "group relative inline-flex items-center gap-3 font-sans uppercase tracking-[0.18em] font-semibold transition-colors duration-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-bone focus-visible:ring-offset-2 focus-visible:ring-offset-ink";
  const sizes = {
    lg: "text-xs sm:text-sm px-8 py-4",
    sm: "text-[0.7rem] px-6 py-3",
  };
  const variants = {
    solid:
      "bg-bone text-ink font-bold hover:bg-transparent hover:text-bone border border-bone",
    outline:
      "bg-transparent text-bone border border-bone/50 hover:bg-bone hover:text-ink hover:border-bone",
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      <span>{children}</span>
      <ArrowRight
        className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1.5"
        strokeWidth={1.5}
      />
    </a>
  );
};
